module.exports = __webpack_public_path__ + "img/filter-dark.f9840799.svg";